/** Preloading and initialization */
export const PRELOAD_DELAY = 100;

/** Caching */
export const CACHE_TTL_MS = 30 * 60 * 1000; // 30 minutes

/** Idle callback timeout */
export const IDLE_CALLBACK_TIMEOUT = 2000;
